import { call, debounce, fork, put, select, takeLatest } from "redux-saga/effects";
import FilmService from "services/filmServices";
import { actions, filmReleaseSelector, filmSearchSelector, tablePaginationSelector } from "./filmListActions";

import { filmTitlesSelector, actions as globalActions } from "components/global/logic/actions";
import {createError, handleServerErrors} from "core/exceptions";
import { assertArray, assertObject } from "core/validation";
import { get } from "lodash";
import log from "loglevel";
import { toast } from "react-toastify";
import FilmReleaseService from "services/filmReleaseService";

function* onSearchFilmReleases() {
    try {
        const form = yield select(filmSearchSelector);
        const hasFilters = Object.keys(form).filter((key) => assertObject(form[key])).length;
        log.debug("[onSearchFilmReleases] ", form, hasFilters);
        if (hasFilters > 0) {
            const paginationParams = yield select(tablePaginationSelector);
            const params = {
                ...form,
                ...paginationParams,
            };
            const data = yield call(FilmService.searchReleases, params);
            yield put(
                actions.ON_SEARCH_FILM_RELEASE.success({
                    list: data.results,
                    total: data.totalCount,
                })
            );
        } else {
            yield put(
                actions.ON_SEARCH_FILM_RELEASE.success({
                    list: [],
                    total: 0,
                })
            );
        }
    } catch (e) {
        log.error(e);
        yield put(actions.ON_SEARCH_FILM_RELEASE.failed(null, createError(e)));
    }
}

function* onSearchFilmReleaseHistory({ payload }) {
    const film = payload;
    try {
        if (film && film.id) {
            const data = yield call(FilmReleaseService.getFilmReleaseHistory, film.id);
            yield put(
                actions.ON_SEARCH_FILM_RELEASE_HISTORY.success({
                    frHistory: data,
                })
            );
        }
    } catch (e) {
        log.error(e);
        yield put(actions.ON_SEARCH_FILM_RELEASE_HISTORY.failed(null, createError(e)));
    }
}

function* updateFilmTable(id) {
    try {
        const filmReleaseSelected = yield select(filmReleaseSelector);

        if (filmReleaseSelected.id === id) {
            yield put(actions.ON_SELECT_FILM_RELEASE.call(null));
        }
        yield put(actions.REFRESH_TABLE.send());
        return true;
    } catch (error) {
        log.error(error);
    }
}

function* updateFilmList(id) {
    try {
        const list = yield select(filmTitlesSelector);
        if (assertArray(list)) {
            const index = list.findIndex((f) => f.id === id);
            if (index !== -1) {
                const newList = list.filter((f, i) => i !== index);
                const payload = {
                    data: newList,
                };
                yield put(globalActions.APP_GET_FILM_TITLE.success(payload));
            }
        }
    } catch (error) {
        log.error(error);
    }
}
export function* deleteFilmRelease({ payload }) {
    const { id, confirmationMessage } = payload;
    try {
        yield call(FilmReleaseService.deleteFilmRelease, id, confirmationMessage);

        yield fork(updateFilmTable, id);
        yield fork(updateFilmList, id);

        yield put(actions.ON_DELETE_FILM.success());
        toast.success("The release was successfully removed", {
            position: "top-right"
        });
    } catch (e) {
        log.error(e);
        handleServerErrors(e, () => {
            const message = get(e.response, "data.error", "There has been an error. Please try again");
            toast.error(message);
        });
        yield put(actions.ON_DELETE_FILM.failed(null, createError(e)));
    }
}
export default [

    debounce(500, actions.ON_SEARCH_FILM_RELEASE.sendType, onSearchFilmReleases),

    debounce(100, actions.ON_CHANGE_PAGINATION_PAGE.type, onSearchFilmReleases),

    debounce(100, actions.ON_CHANGE_PAGINATION_MAX_RESULTS.type, onSearchFilmReleases),
    takeLatest(actions.REFRESH_TABLE.sendType, onSearchFilmReleases),
    takeLatest(actions.ON_CHANGE_ORDER.type, onSearchFilmReleases),
    takeLatest(actions.ON_DELETE_FILM.sendType, deleteFilmRelease),
    takeLatest(actions.ON_SEARCH_FILM_RELEASE_HISTORY.sendType, onSearchFilmReleaseHistory),
];
